import type { Category } from '../types';

const categories: Category[] = [
  {
    title: 'Tools',
  },
  {
    title: 'Wallets',
  },
  {
    title: 'dApps',
  },
  {
    title: 'Partners',
  },
  {
    title: 'Exchanges',
  }
];

export default categories;
